import { twMerge } from '@/lib/classname/twMerge'
import { Loader } from '../loader/Loader'

export type LoadingOverlayProps = UiComponentProps<{
  isVisible?: boolean
}>

export function LoadingOverlay({
  isVisible,
  className,
  id,
  'data-testid': dataTestId = 'loading-overlay',
  'aria-label': ariaLabel,
}: LoadingOverlayProps): React.ReactElement | null {
  if (!isVisible) return null

  return (
    <div
      id={id}
      aria-label={ariaLabel}
      className={twMerge(className, 'absolute inset-0 flex items-center justify-center')}
      data-testid={dataTestId}
    >
      <Loader />
    </div>
  )
}
